import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";

import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { toastAlert } from "../../lib/toastAlert";

//import avatar from "assets/img/faces/marc.jpg";
import isEmpty from "../../lib/isEmpty";

import { getEmailid, updateEmail, getSedMails } from "../../actions/users";
import config from "../../lib/config";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

// toaster config
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

const initialFormValue = {
  identifier: "",
  subject: "",
  content: ""
};

const useStyles = makeStyles(styles);

const useStyles1 = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: 500
  },
  indeterminateColor: {
    color: "#f50057"
  },
  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  }
}));

var template =
  '<p>&nbsp;</p><table style="padding: 0; background: #16181d ;     url(\'https://epoch.wealwin.com/images/email_images/emailBg.png\') no-repeat      scroll 0 20%; max-width: 650px;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td><table style="margin: 0; padding: 15px; text-align: center;" border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td><a href="alwin.io"><img src="https://dopamineapi.wealwin.com/cmsimage/logo.png" width="150px" height="30px" /></a></td></tr></tbody></table></td></tr><tr><td height="10">&nbsp;</td></tr><tr><td><table style="margin: 0 auto; background: rgba(22, 24, 29, 0.6); padding: 20px;" border="0" width="95%" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td style="margin: 0; padding: 0;"><p style="font-family: Arial, Helvetica, sans-serif; margin: 0 0 15px 0; padding: 0; color: #ffffff; font-size: 15px; font-weight: normal;">Dear User,</p><p style="font-family: Arial, Helvetica, sans-serif; margin: 0 0 5px 0; padding: 0; color: #ffffff; font-size: 15px; font-weight: normal;">Hi Dopamine Users! This our monthly Newletter. More information please check with our site.</p><p style="font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color: #ffffff; font-size: 15px; font-weight: normal; line-height: 20px;">Thanks &amp; Regards,<br />Dopamine NFT Martketplace</p></td></tr></tbody></table></td></tr><tr><td height="5">&nbsp;</td></tr><tr><td style="margin: 0; padding: 12px 0; text-align: center; font-size: 15px; color: #aeaeae; font-family: Arial, Helvetica, sans-serif;"><a style="color: #aeaeae; text-decoration: none;" href="mailto:support@dopamine.io" target="_blank" rel="noopener"><strong>Dopamine NFT Marketplace</strong><br />Email : &nbsp;support@dopamine.io</a></td></tr><tr><td style="margin: 0; padding: 0px 0 7px; text-align: center; font-size: 15px; color: #ffba00; font-family: Arial, Helvetica, sans-serif;">Join our community<p style="font-size: 0; line-height: 0; padding: 0; margin: 10px 0 0 0;"><a style="margin: 0 15px 0 12px;" href="https://twitter.com/dopamine2022" target="_blank" rel="noopener"> <img src="https://dopamineapi.wealwin.com/cmsimage/twiter.png" /></a><a style="margin: 0 15px 0 12px;" href="https://www.facebook.com/dopamine/" target="_blank" rel="noopener"> <img src="https://dopamineapi.wealwin.com/cmsimage/facbook.png" /></a><a style="margin: 0 15px 0 12px;" href="https://discord.com/invite/dopamine" target="_blank" rel="noopener"><img src="https://nftplatformapi.wealwin.com/cmsimage/discord.png" /></a></p></td></tr><tr><td height="10">&nbsp;</td></tr></tbody></table>';

export default function NewsLetter(props) {
  const [mailContent, setmailContent] = useState(template);
  const classes = useStyles();
  const classes1 = useStyles1();
  const history = useHistory();
  const dispatch = useDispatch();
  const [userdet, setUser] = useState();
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});
  const [maillist, setmaillist] = useState([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };

  const options = maillist;

  const [selected, setSelected] = useState([]);
  const isAllSelected =
    options.length > 0 && selected.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
  };

  const getMailData = () => {
    axios
      .get(`${config.baseUrl}/api/user/requestsubscribe`)
      .then((res) => {
        console.log(res.data.data, "resss--ress");
        var arrmail = [];
        let mymails = res.data.data;
        mymails.map((item, i) => {
          console.log(item, "ii");
          const name = item.email;
          var obj = name;
          arrmail.push(obj);
          console.log(obj, "ofofofof");
          console.log(arrmail, "arrmail");
        });
        setmaillist(arrmail);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getMailData();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const newsletter = {
      email: selected,
      message: mailContent
    };
    let report = await getSedMails(newsletter);
    toastAlert("sucess", "Email send successfully", toasterOption);
    console.log(report, "reporttt");
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form
              className={classes.form}
              noValidate
              onSubmit={handleFormSubmit}
            >
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  Update News Letter Template
                </h4>
              </CardHeader>
              <CardBody>
                <FormControl className={classes1.formControl}>
                  <InputLabel id="mutiple-select-label">
                    Multiple Select
                  </InputLabel>
                  <Select
                    labelId="mutiple-select-label"
                    multiple
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    <MenuItem
                      value="all"
                      classes={{
                        root: isAllSelected ? classes1.selectedAll : ""
                      }}
                    >
                      <ListItemIcon>
                        <Checkbox
                          classes={{
                            indeterminate: classes1.indeterminateColor
                          }}
                          checked={isAllSelected}
                          indeterminate={
                            selected.length > 0 &&
                            selected.length < options.length
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        classes={{ primary: classes1.selectAllText }}
                        primary="Select All"
                      />
                    </MenuItem>
                    {options.map((option) => (
                      <MenuItem key={option} value={option}>
                        <ListItemIcon>
                          <Checkbox checked={selected.indexOf(option) > -1} />
                        </ListItemIcon>
                        <ListItemText primary={option} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <GridContainer>
                  {/* <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      disabled
                      labelText="Identifier"
                    //   onChange={onChange}
                      id="identifier"
                      value={identifier}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                    {validateError.identifier && (
                      <span className={classes.textDanger}>
                        {validateError.identifier}
                      </span>
                    )}
                  </GridItem> */}

                  {/* <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Subject"
                    //   onChange={onChange}
                      id="subject"
                      value={subject}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                    {validateError.subject && (
                      <span className={classes.textDanger}>
                        {validateError.subject}
                      </span>
                    )}
                  </GridItem> */}
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <p className={classes.cardCategoryWhite}>
                      Create a new user
                    </p>
                    <Editor
                      apiKey="j2crzkts7ankhknggcx4ku2xkuiaxsiruhwg1e01cfwvmbpq"
                      // initialValue={content}
                      value={template}
                      //   onEditorChange={onchangeeditor}
                      id="mailContent"
                      name="mailContent"
                      init={{
                        height: 500,
                        menubar: false,
                        plugins: [
                          "advlist autolink lists link image charmap print preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste code help wordcount"
                        ],
                        toolbar:
                          "undo redo code | formatselect | bold italic backcolor | \
                          alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help"
                      }}
                    />

                    {/* {validateError.content && (
                      <span className={classes.textDanger}>
                        {validateError.content}
                      </span>
                    )} */}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit">
                  Send
                </Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
